import React from "react";
import ButtonContainer from "components/Global/Alerts/ButtonContainer";
import PrimaryAction from "components/Global/Alerts/PrimaryAction";
import SecondaryAction from "components/Global/Alerts/SecondaryAction";

const styles = {
  wrapper: {
    position: "relative"
  },
  label: {},
  menu: {
    "border-radius": "4px",
    "box-shadow": "0 1px 5px 0 rgb(0 0 0 / 14%)",
    position: "absolute",
    bottom: "20px",
    right: "10px",
    padding: "13px 22px",
    color: "#4a4a4a",
    "font-size": "14px",
    "line-height": "1.3em",
    background: "white"
  },
  header: {
    color: "#4a4a4a",
    "font-size": "14px",
    "font-weight": "700",
    "margin-bottom": "10px"
  },
  hr: {
    border: "solid hsla(0,0%,59.2%,.26)",
    "border-width": "1px 0 0",
    margin: "12px 0 10px"
  },
  close: {
    float: "right"
  }
};
const DeleteConfirmationPopover = ({
  onClose,
  onLabelClick,
  onConfirm,
  isOpen,
  Label,
  styleMenu = {}
}) => {
  return (
    <div
      className={"session-content-delete-confirmation"}
      style={styles.wrapper}
    >
      <div
        style={styles.label}
        onClick={() => {
          onLabelClick(!open);
        }}
      >
        {Label}
      </div>

      {isOpen && (
        <div style={{ ...styles.menu, ...styleMenu }}>
          <div style={styles.header}>Are you sure?</div>
          <div style={styles.text}>
            This will delete this version of the file
          </div>
          <hr style={styles.hr} />
          <div>
            <ButtonContainer>
              <PrimaryAction
                onClick={() => {
                  onConfirm();
                }}
                style={{}}
              >
                Delete
              </PrimaryAction>
              <SecondaryAction onClick={onClose}>Cancel</SecondaryAction>
            </ButtonContainer>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteConfirmationPopover;
